// Form error messages
export const FORM_ERROR_MESSAGES = {
  REQUIRED_OPTION: 'Please select an option',
  REQUIRED_FIELD: 'This field cannot be left blank',
  LENGTH_MIN: 'This field is too short',
  LENGTH_MAX: 'This field is too long',
  PATTERN_ERROR: 'Please check your drone\'s serial number and try again. You can find guidance on finding the correct serial number on the <a href="https://www.casa.gov.au/drones/register/serial-numbers" target="_blank">CASA website</a>',
  DECLARATION: 'You must accept the declaration.',
  DUPLICATE_RPA: 'An RPA with these details already exists',
  INVALID_NAME: 'Please enter a valid name',
  INVALID_ENTRY: 'Invalid entry',
  INVALID_MODEL_DJI_OTHER: 'CASA no longer accepts \'Other\' as a model for all DJI drones. You will need to select a new model for this drone before it can be renewed.'
};

export const DRONE_CONSTANTS = {
  OTHER_MANUFACTURER_CODE: 'RPAMFR-0002',
  HOME_BUILT_MANUFACTURER_CODE: 'RPAMFR-0001',
  OTHER_MODEL_CODE_EXT: '-OTH',
  AIRSHIP_CATEGORY_CODE: 'RPACAT-004',
  AIRSHIP_CATEGORY_WEIGHT_CLASS: 'RPAWC-00007',
  DJI_MANUFACTURER_CODE: 'RPAMFR-0003'
};

export const FCL_CONSTANTS = {
  FLIGHT_INSTRUCTOR_RATING: 'FLIGHT INSTRUCTOR RATING',
  FLIGHT_EXAMINER_RATING: 'FLIGHT EXAMINER RATING'
};